import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomModal from "./CustomModal";
import { AdminApis } from "../../apis/adminApi";
import {
  FaTrash,
  FaEdit,
  FaPlus,
  FaImage,
  FaStore,
  FaExternalLinkAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaSpinner,
  FaArrowLeft,
} from "react-icons/fa";
import { IoIosAddCircle, IoMdClose } from "react-icons/io";
import { AiOutlineWarning } from "react-icons/ai";
import { Oval } from "react-loader-spinner";
import InputColor from "react-input-color";

export default function CardCreateProduct() {
  const navigate = useNavigate();

  const [modals, setModals] = useState({
    createMarketLink: false,
    editMarketLink: false,
    deleteMarketLink: false,
  });

  const [productForm, setProductForm] = useState({
    name: "",
    description: "",
    phoneNumber: "",
    discountedPrice: "",
    category: "all",
    location: "",
    price: "",
    marketLinkId: "",
    whatsappLink: "",
  });

  const [marketLinkForm, setMarketLinkForm] = useState({
    name: "",
    color: { hex: "#0071BC" },
    description: "",
    facebookUrl: "",
    instagramUrl: "",
    tiktokUrl: "",
    logo: "No selected file",
  });

  const [productLinks, setProductLinks] = useState([]);
  const [whatsappLinks, setWhatsappLinks] = useState([]);
  const [userData, setUserData] = useState({});

  const [productImages, setProductImages] = useState({
    image1: { file: "No selected file", preview: "empty" },
    image2: { file: "No selected file", preview: "empty" },
    image3: { file: "No selected file", preview: "empty" },
  });

  const [logoPreview, setLogoPreview] = useState("empty");
  const [loading, setLoading] = useState(false);
  const [linkAvailability, setLinkAvailability] = useState({ available: null, checking: false });
  const [selectedLinkId, setSelectedLinkId] = useState("");
  const [editingMarketLink, setEditingMarketLink] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const categories = [
    { value: "all", label: "All Categories" },
    { value: "women fashion", label: "Women's Fashion" },
    { value: "men fashion", label: "Men's Fashion" },
    { value: "beauty&cosmetics", label: "Beauty and Cosmetics" },
    { value: "bags", label: "Bags" },
    { value: "sport/outdoor", label: "Sport/Outdoor" },
    { value: "home/kitchen", label: "Home/Kitchen" },
    { value: "shoes", label: "Shoes" },
    { value: "watches", label: "Watches" },
    { value: "keyboard & mice", label: "Keyboard & Mice" },
    { value: "laptops", label: "Laptops" },
    { value: "phones", label: "Phones" },
  ];

  const nigerianStates = [
    "Abuja FCT", "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa",
    "Benue", "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu",
    "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi",
    "Kwara", "Lagos", "Nassarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo",
    "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara",
  ];

  useEffect(() => {
    fetchWhatsappLinks();
    fetchMarketLinks();
  }, [refresh]);

  useEffect(() => {
    if (marketLinkForm.name.length > 0) {
      setLinkAvailability({ available: null, checking: true });
      const id = setTimeout(checkLinkAvailability, 500);
      return () => clearTimeout(id);
    }
  }, [marketLinkForm.name]);

  const fetchWhatsappLinks = async () => {
    try {
      const res = await AdminApis.getlinks();
      if (res?.data) setWhatsappLinks(res.data.link || []);
    } catch {}
  };

  const fetchMarketLinks = async () => {
    try {
      const res = await AdminApis.getMarketLink();
      if (res?.data) {
        setProductLinks(res.data.link || []);
        setUserData(res.data.user_data || {});
      }
    } catch {}
  };

  const checkLinkAvailability = async () => {
    try {
      const clean = marketLinkForm.name.toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-zA-Z0-9-]/g, "");
      const res = await AdminApis.checkMarketLink({ link_name: clean });
      setLinkAvailability({ available: res?.data?.link === 0, checking: false });
    } catch {
      setLinkAvailability({ available: false, checking: false });
    }
  };

  const toggleModal = (name, state = null) =>
    setModals((prev) => ({ ...prev, [name]: state !== null ? state : !prev[name] }));

  const openCreateMarketLinkModal = () => {
    if (parseInt(userData?.no_of_malink || 0) > productLinks.length) {
      toggleModal("createMarketLink", true);
    } else {
      toast.error("Market link limit exceeded");
    }
  };

  const openEditMarketLinkModal = (link) => {
    setEditingMarketLink(link);
    const safeStr = (v) => (!v || v === "null") ? "" : v;
    setMarketLinkForm({
      name: link.link_name,
      color: { hex: safeStr(link.brand_primary_color) || "#0071BC" },
      description: safeStr(link.brand_description),
      facebookUrl: safeStr(link.facebook_url),
      instagramUrl: safeStr(link.instagram_url),
      tiktokUrl: safeStr(link.tiktok_url),
      logo: "No selected file",
    });
    toggleModal("editMarketLink", true);
  };

  const openDeleteMarketLinkModal = (id) => {
    setSelectedLinkId(id);
    toggleModal("deleteMarketLink", true);
  };

  const handleImageUpload = (e, key) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size / 1048576 > 4) {
      e.target.value = "";
      toast.warn("Max image size is 4 MB.");
      return;
    }
    const preview = URL.createObjectURL(file);
    if (key === "logo") {
      setMarketLinkForm((p) => ({ ...p, logo: file }));
      setLogoPreview(preview);
    } else {
      setProductImages((p) => ({ ...p, [key]: { file, preview } }));
    }
  };

  const handleProductFormChange = (field, value) =>
    setProductForm((p) => ({ ...p, [field]: value }));

  const handleMarketLinkFormChange = (field, value) =>
    setMarketLinkForm((p) => ({ ...p, [field]: value }));

  /* ─── API calls ─────────────────────────────────────────────────────── */
  const createProduct = async (e) => {
    e.preventDefault();
    if (productImages.image1.file === "No selected file") {
      toast.error("Please upload at least one product image");
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      const [linkName, linkId] = productForm.marketLinkId.split(" ");
      fd.append("link_name", linkName);
      fd.append("link_id", linkId);
      fd.append("product_name", productForm.name);
      fd.append("product_description", productForm.description);
      fd.append("phone_number", productForm.whatsappLink);
      fd.append("no_of_items", productForm.discountedPrice);
      fd.append("product_price", productForm.price);
      fd.append("category", productForm.category);
      fd.append("location", productForm.location);
      fd.append("product_image_1", productImages.image1.file);
      fd.append("product_image_2", productImages.image2.file);
      fd.append("product_image_3", productImages.image3.file);
      const res = await AdminApis.createProduct(fd);
      if (res?.data) {
        toast.success(res.data.message);
        navigate("/mini-store");
      } else {
        toast.error(res?.response?.data?.message || "Failed to create product");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create product");
    } finally {
      setLoading(false);
    }
  };

  const createMarketLink = async (e) => {
    e.preventDefault();
    if (!linkAvailability.available) { toast.error("Please choose an available link name"); return; }
    try {
      const fd = new FormData();
      const clean = marketLinkForm.name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "");
      fd.append("link_name", clean);
      fd.append("brand_primary_color", marketLinkForm.color.hex);
      fd.append("brand_description", marketLinkForm.description);
      fd.append("facebook_url", marketLinkForm.facebookUrl);
      fd.append("instagram_url", marketLinkForm.instagramUrl);
      fd.append("tiktok_url", marketLinkForm.tiktokUrl);
      fd.append("brand_logo", marketLinkForm.logo);
      const res = await AdminApis.createMarketLink(fd);
      if (res?.data) {
        toast.success(res.data.message);
        setRefresh(!refresh);
        toggleModal("createMarketLink", false);
        resetMarketLinkForm();
      } else {
        toast.error(res?.response?.data?.message || "Failed");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed");
    }
  };

  const updateMarketLink = async (e) => {
    e.preventDefault();
    try {
      const fd = new FormData();
      fd.append("link_name", editingMarketLink.link_name);
      fd.append("brand_primary_color", marketLinkForm.color.hex);
      fd.append("brand_description", marketLinkForm.description || editingMarketLink.brand_description);
      fd.append("facebook_url", marketLinkForm.facebookUrl || editingMarketLink.facebook_url);
      fd.append("instagram_url", marketLinkForm.instagramUrl || editingMarketLink.instagram_url);
      fd.append("tiktok_url", marketLinkForm.tiktokUrl || editingMarketLink.tiktok_url);
      fd.append("brand_logo", marketLinkForm.logo);
      fd.append("id", editingMarketLink.id);
      const res = await AdminApis.updateMarketLink(fd);
      if (res?.data) {
        toast.success(res.data.message);
        setRefresh(!refresh);
        toggleModal("editMarketLink", false);
        resetMarketLinkForm();
      } else {
        toast.error(res?.response?.data?.message || "Failed");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed");
    }
  };

  const deleteMarketLink = async () => {
    setLoading(true);
    try {
      const res = await AdminApis.deleteMarketLink(selectedLinkId);
      if (res?.data) {
        toast.success(res.data.message);
        setRefresh(!refresh);
        toggleModal("deleteMarketLink", false);
      } else {
        toast.error(res?.response?.data?.message || "Failed");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed");
    } finally {
      setLoading(false);
    }
  };

  const resetMarketLinkForm = () => {
    setMarketLinkForm({ name: "", color: { hex: "#0071BC" }, description: "", facebookUrl: "", instagramUrl: "", tiktokUrl: "", logo: "No selected file" });
    setLogoPreview("empty");
  };

  /* ─── Sub-components ─────────────────────────────────────────────────── */
  const ImageSlot = ({ imageKey, preview, label, required = false, isLogo = false }) => (
    <label className="group relative flex flex-col cursor-pointer">
      <div className={`relative overflow-hidden rounded-xl border-2 border-dashed transition-all duration-200 ${
        preview !== "empty"
          ? "border-blue-400 bg-white"
          : "border-gray-200 bg-gray-50 hover:border-blue-300 hover:bg-blue-50/30"
      } ${isLogo ? "h-28" : "aspect-square"}`}>
        {preview !== "empty" ? (
          <>
            <img src={preview} alt="preview" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                if (isLogo) {
                  setLogoPreview("empty");
                  setMarketLinkForm((p) => ({ ...p, logo: "No selected file" }));
                } else {
                  setProductImages((p) => ({ ...p, [imageKey]: { file: "No selected file", preview: "empty" } }));
                }
              }}
              className="absolute top-1.5 right-1.5 w-6 h-6 bg-white/90 hover:bg-white rounded-full shadow flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <IoMdClose size={13} className="text-gray-600" />
            </button>
          </>
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 text-gray-400 group-hover:text-blue-500 transition-colors">
            <FaImage size={isLogo ? 20 : 24} />
            <span className="text-xs font-medium">{label}{required && " *"}</span>
            <span className="text-[10px] text-gray-400">Max 4 MB</span>
          </div>
        )}
      </div>
      <input type="file" className="hidden" accept="image/*" onChange={(e) => handleImageUpload(e, imageKey)} />
    </label>
  );

  const SectionHeader = ({ number, title, subtitle }) => (
    <div className="flex items-start gap-3 mb-5">
      <div className="flex-shrink-0 w-8 h-8 bg-blue-600 text-white text-sm font-bold rounded-xl flex items-center justify-center shadow-sm">
        {number}
      </div>
      <div>
        <h3 className="text-base font-bold text-gray-900 leading-tight">{title}</h3>
        {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
    </div>
  );

  const FieldLabel = ({ children, required }) => (
    <label className="block text-sm font-semibold text-gray-700 mb-1.5">
      {children}{required && <span className="text-red-500 ml-1">*</span>}
    </label>
  );

  const inputCls = "w-full px-3.5 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white transition-all";

  /* ─── Link availability indicator ─────────────────────────────────── */
  const LinkStatus = () => {
    if (linkAvailability.checking) return (
      <span className="flex items-center gap-1 text-xs text-gray-500">
        <FaSpinner className="animate-spin" size={11} /> Checking…
      </span>
    );
    if (linkAvailability.available === true) return (
      <span className="flex items-center gap-1 text-xs text-emerald-600 font-medium">
        <FaCheckCircle size={11} /> Available
      </span>
    );
    if (linkAvailability.available === false) return (
      <span className="flex items-center gap-1 text-xs text-red-500 font-medium">
        <FaTimesCircle size={11} /> Already taken
      </span>
    );
    return null;
  };


  const hasStore = productLinks.length > 0;
  const hasWhatsapp = whatsappLinks.length > 0;
  const isReady = hasStore && hasWhatsapp;

  /* ─── Render ─────────────────────────────────────────────────────────── */
  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <div className="max-w-5xl mx-auto px-4 py-8">

        {/* Header */}
        <div className="flex items-center gap-4 mb-6">
          <button
            type="button"
            onClick={() => navigate("/mini-store")}
            className="w-9 h-9 flex items-center justify-center rounded-xl bg-white border border-gray-200 text-gray-500 hover:text-gray-800 hover:shadow-sm transition-all"
          >
            <FaArrowLeft size={14} />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Add New Product</h1>
            <p className="text-sm text-gray-500 mt-0.5">List a product on the marketplace in 4 simple steps</p>
          </div>
        </div>

        {/* ── How it works (shown only when user has no stores) ── */}
        {!hasStore && (
          <div className="bg-blue-600 rounded-2xl p-6 mb-6 text-white">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <FaStore size={18} />
              </div>
              <div className="flex-1">
                <h2 className="font-bold text-lg leading-tight">First, create a store</h2>
                <p className="text-blue-100 text-sm mt-1 max-w-xl">
                  A <strong className="text-white">store</strong> is your public marketplace page where all your products are listed. Customers browse your store and contact you directly via WhatsApp to purchase. You need at least one store before you can add products.
                </p>
                <div className="flex flex-wrap gap-3 mt-4">
                  <button
                    type="button"
                    onClick={openCreateMarketLinkModal}
                    className="flex items-center gap-2 px-4 py-2.5 bg-white text-blue-600 text-sm font-bold rounded-xl hover:bg-blue-50 transition-colors shadow-sm"
                  >
                    <FaStore size={13} /> Create My Store
                  </button>
                  <div className="flex items-center gap-2 text-blue-200 text-xs">
                    <span>→</span> Takes less than a minute
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Setup Checklist (always visible until both are ready) ── */}
        {!isReady && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 mb-6">
            <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Setup Checklist</p>
            <div className="space-y-2.5">
              {/* Store check */}
              <div className={`flex items-center justify-between px-3 py-2.5 rounded-xl ${hasStore ? "bg-green-50" : "bg-amber-50 border border-amber-100"}`}>
                <div className="flex items-center gap-3">
                  {hasStore
                    ? <FaCheckCircle size={15} className="text-green-500 flex-shrink-0" />
                    : <FaTimesCircle size={15} className="text-amber-500 flex-shrink-0" />
                  }
                  <div>
                    <p className={`text-sm font-semibold ${hasStore ? "text-green-800" : "text-amber-800"}`}>
                      {hasStore ? `Store ready — ${productLinks.length} store${productLinks.length > 1 ? "s" : ""}` : "No store created yet"}
                    </p>
                    {!hasStore && <p className="text-xs text-amber-600 mt-0.5">Products must belong to a store to appear on the marketplace</p>}
                  </div>
                </div>
                {!hasStore && (
                  <button
                    type="button"
                    onClick={openCreateMarketLinkModal}
                    className="flex-shrink-0 flex items-center gap-1.5 px-3 py-1.5 bg-amber-500 text-white text-xs font-bold rounded-lg hover:bg-amber-600 transition-colors"
                  >
                    <FaPlus size={9} /> Create Store
                  </button>
                )}
              </div>
              {/* WhatsApp check */}
              <div className={`flex items-center justify-between px-3 py-2.5 rounded-xl ${hasWhatsapp ? "bg-green-50" : "bg-amber-50 border border-amber-100"}`}>
                <div className="flex items-center gap-3">
                  {hasWhatsapp
                    ? <FaCheckCircle size={15} className="text-green-500 flex-shrink-0" />
                    : <FaTimesCircle size={15} className="text-amber-500 flex-shrink-0" />
                  }
                  <div>
                    <p className={`text-sm font-semibold ${hasWhatsapp ? "text-green-800" : "text-amber-800"}`}>
                      {hasWhatsapp ? `WhatsApp contact ready — ${whatsappLinks.length} link${whatsappLinks.length > 1 ? "s" : ""}` : "No WhatsApp contact added"}
                    </p>
                    {!hasWhatsapp && <p className="text-xs text-amber-600 mt-0.5">Customers contact you via WhatsApp when they want to buy</p>}
                  </div>
                </div>
                {!hasWhatsapp && (
                  <Link
                    to="/mylinks"
                    className="flex-shrink-0 flex items-center gap-1.5 px-3 py-1.5 bg-green-600 text-white text-xs font-bold rounded-lg hover:bg-green-700 transition-colors"
                  >
                    <FaPlus size={9} /> Add Contact
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}

        <form onSubmit={createProduct}>
          <div className="grid lg:grid-cols-5 gap-6">

            {/* ── Left Column (form) ─────────────────────────────────── */}
            <div className="lg:col-span-3 space-y-5">

              {/* Section 1 – Store Assignment (prerequisite — moved to top) */}
              <div className={`bg-white rounded-2xl border shadow-sm p-6 ${!isReady ? "border-amber-200" : "border-gray-100"}`}>
                <SectionHeader
                  number="1"
                  title="Store & Contact"
                  subtitle="Choose which store this product belongs to, and which WhatsApp number customers should reach"
                />
                <div className="grid sm:grid-cols-2 gap-4">
                  {/* Store */}
                  <div>
                    <div className="flex items-center justify-between mb-1.5">
                      <FieldLabel required>Market Store</FieldLabel>
                      <button
                        type="button"
                        onClick={openCreateMarketLinkModal}
                        className="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-700 font-semibold"
                      >
                        <IoIosAddCircle size={15} /> New store
                      </button>
                    </div>
                    {productLinks.length === 0 ? (
                      <button
                        type="button"
                        onClick={openCreateMarketLinkModal}
                        className="w-full flex flex-col items-center justify-center gap-1.5 py-5 border-2 border-dashed border-blue-300 bg-blue-50 rounded-xl text-blue-600 hover:bg-blue-100 transition-colors"
                      >
                        <FaStore size={22} className="text-blue-400" />
                        <span className="text-sm font-semibold">Create your first store</span>
                        <span className="text-xs text-blue-400">Your products will appear here</span>
                      </button>
                    ) : (
                      <select
                        required
                        value={productForm.marketLinkId}
                        onChange={(e) => handleProductFormChange("marketLinkId", e.target.value)}
                        className={inputCls}
                      >
                        <option value="">Select store…</option>
                        {productLinks.map((l) => (
                          <option key={l.id} value={`${l.link_name} ${l.id}`}>
                            {l.link_name}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  {/* WhatsApp */}
                  <div>
                    <div className="flex items-center justify-between mb-1.5">
                      <FieldLabel required>WhatsApp Contact</FieldLabel>
                      <Link to="/mylinks" className="flex items-center gap-1 text-xs text-green-600 hover:text-green-700 font-semibold">
                        <IoIosAddCircle size={15} /> Add link
                      </Link>
                    </div>
                    {whatsappLinks.length === 0 ? (
                      <Link
                        to="/mylinks"
                        className="w-full flex flex-col items-center justify-center gap-1.5 py-5 border-2 border-dashed border-green-300 bg-green-50 rounded-xl text-green-600 hover:bg-green-100 transition-colors"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" className="text-green-400">
                          <path fill="currentColor" d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28" />
                        </svg>
                        <span className="text-sm font-semibold">Add WhatsApp contact</span>
                        <span className="text-xs text-green-400">Customers contact you here</span>
                      </Link>
                    ) : (
                      <select
                        required
                        value={productForm.whatsappLink}
                        onChange={(e) => handleProductFormChange("whatsappLink", e.target.value)}
                        className={inputCls}
                      >
                        <option value="">Select contact…</option>
                        {whatsappLinks.map((l) => (
                          <option key={l.id} value={l.name}>{l.name}</option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>

                {/* Existing stores mini-list (visible contextually) */}
                {productLinks.length > 0 && (
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">Your Stores</p>
                    <div className="flex flex-wrap gap-2">
                      {productLinks.map((link) => (
                        <div key={link.id} className="flex items-center gap-1.5 px-2.5 py-1 bg-gray-50 border border-gray-200 rounded-lg">
                          <div className="w-3 h-3 rounded-full" style={{ backgroundColor: link.brand_primary_color || "#2563EB" }} />
                          <span className="text-xs font-medium text-gray-700">{link.link_name}</span>
                          <a href={`https://mygupta.co/s/${link.link_name}`} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-500 transition-colors">
                            <FaExternalLinkAlt size={9} />
                          </a>
                          {(userData?.sub_type === "premium" || userData?.sub_type === "free") && (
                            <button type="button" onClick={() => openEditMarketLinkModal(link)} className="text-gray-300 hover:text-blue-500 transition-colors">
                              <FaEdit size={9} />
                            </button>
                          )}
                          <button type="button" onClick={() => openDeleteMarketLinkModal(link.id)} className="text-gray-300 hover:text-red-500 transition-colors">
                            <FaTrash size={9} />
                          </button>
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={openCreateMarketLinkModal}
                        className="flex items-center gap-1 px-2.5 py-1 border border-dashed border-blue-300 rounded-lg text-blue-500 text-xs font-semibold hover:bg-blue-50 transition-colors"
                      >
                        <FaPlus size={9} /> New store
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Section 2 – Product Info */}
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                <SectionHeader number="2" title="Product Information" subtitle="Basic details visible to your customers" />
                <div className="space-y-4">
                  <div>
                    <FieldLabel required>Product Name</FieldLabel>
                    <input
                      type="text"
                      required
                      value={productForm.name}
                      onChange={(e) => handleProductFormChange("name", e.target.value)}
                      className={inputCls}
                      placeholder="e.g. Ladies Floral Dress"
                    />
                  </div>
                  <div>
                    <FieldLabel required>Description</FieldLabel>
                    <textarea
                      required
                      rows={4}
                      value={productForm.description}
                      onChange={(e) => handleProductFormChange("description", e.target.value)}
                      className={`${inputCls} resize-none`}
                      placeholder="Describe size, material, colour options, and key features…"
                    />
                  </div>
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                      <FieldLabel>Category</FieldLabel>
                      <select value={productForm.category} onChange={(e) => handleProductFormChange("category", e.target.value)} className={inputCls}>
                        {categories.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                      </select>
                    </div>
                    <div>
                      <FieldLabel>Location</FieldLabel>
                      <select value={productForm.location} onChange={(e) => handleProductFormChange("location", e.target.value)} className={inputCls}>
                        <option value="">Select state</option>
                        {nigerianStates.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 3 – Pricing */}
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                <SectionHeader number="3" title="Pricing" subtitle="Set your regular and discounted prices" />
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <FieldLabel required>Sales Price (₦)</FieldLabel>
                    <input
                      type="number"
                      required
                      min="0"
                      value={productForm.price}
                      onChange={(e) => handleProductFormChange("price", e.target.value)}
                      className={inputCls}
                      placeholder="e.g. 5000"
                    />
                  </div>
                  <div>
                    <FieldLabel>Discounted Price (₦) <span className="text-gray-400 font-normal text-xs">(optional)</span></FieldLabel>
                    <input
                      type="number"
                      min="0"
                      value={productForm.discountedPrice}
                      onChange={(e) => handleProductFormChange("discountedPrice", e.target.value)}
                      className={inputCls}
                      placeholder="e.g. 3500"
                    />
                  </div>
                </div>
                {productForm.price && productForm.discountedPrice && parseFloat(productForm.discountedPrice) < parseFloat(productForm.price) && (
                  <p className="mt-2.5 text-xs text-emerald-600 font-medium">
                    Showing a {Math.round((1 - parseFloat(productForm.discountedPrice) / parseFloat(productForm.price)) * 100)}% discount badge on your listing
                  </p>
                )}
              </div>
            </div>

            {/* ── Right Column (images + submit) ─────────────────────── */}
            <div className="lg:col-span-2 space-y-5">

              {/* Section 4 – Images */}
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                <SectionHeader number="4" title="Product Images" subtitle="First image is shown as the cover" />
                <div className="space-y-3">
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Cover Image *</p>
                    <ImageSlot imageKey="image1" preview={productImages.image1.preview} label="Upload Cover" required />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { key: "image2", label: "Image 2" },
                      { key: "image3", label: "Image 3" },
                    ].map(({ key, label }) => (
                      <div key={key}>
                        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">{label}</p>
                        <ImageSlot imageKey={key} preview={productImages[key].preview} label="Upload" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={loading || !isReady}
                className={`w-full flex items-center justify-center gap-2 py-3.5 font-bold text-sm rounded-2xl shadow-md transition-all duration-200 ${
                  isReady
                    ? "bg-blue-600 hover:bg-blue-700 text-white hover:shadow-lg"
                    : "bg-gray-200 text-gray-400 cursor-not-allowed shadow-none"
                }`}
              >
                {loading ? (
                  <><Oval height={16} width={16} color="#fff" secondaryColor="#bfdbfe" /> Publishing…</>
                ) : isReady ? (
                  "Publish Product"
                ) : (
                  "Complete setup above first"
                )}
              </button>

              {!isReady && (
                <p className="text-xs text-center text-gray-400">
                  Create a store and add a WhatsApp contact to enable publishing
                </p>
              )}
            </div>
          </div>
        </form>
      </div>

      {/* ── Modals ─────────────────────────────────────────────────────── */}
      <CustomModal isOpen={modals.createMarketLink} onClose={() => toggleModal("createMarketLink", false)} title="Create New Store" maxWidth="max-w-xl">
        <form onSubmit={createMarketLink} className="space-y-1">
          <div className="space-y-4">
            <div>
              <FieldLabel required>Store URL Name</FieldLabel>
              <div className="relative">
                <input
                  type="text"
                  required
                  value={marketLinkForm.name}
                  onChange={(e) => handleMarketLinkFormChange("name", e.target.value)}
                  className={inputCls}
                  placeholder="e.g. john-fashion"
                />
              </div>
              <div className="flex items-center justify-between mt-1.5">
                <p className="text-[11px] text-gray-400">
                  mygupta.co/s/{marketLinkForm.name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "")}
                </p>
                <LinkStatus />
              </div>
            </div>
            {(userData?.sub_type === "premium" || userData?.sub_type === "popular" || userData?.sub_type === "free") && (
              <>
                <div>
                  <FieldLabel>Brand Color</FieldLabel>
                  <div className="flex items-center gap-3">
                    <InputColor initialValue="#0071BC" onChange={(c) => handleMarketLinkFormChange("color", c)} placement="right" />
                    <div className="flex-1 h-10 rounded-xl border-2 border-gray-200 flex items-center justify-center text-white text-xs font-bold" style={{ backgroundColor: marketLinkForm.color.hex }}>
                      {marketLinkForm.color.hex}
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-3">
                  <input type="url" value={marketLinkForm.facebookUrl} onChange={(e) => handleMarketLinkFormChange("facebookUrl", e.target.value)} className={inputCls} placeholder="Facebook URL" />
                  <input type="url" value={marketLinkForm.instagramUrl} onChange={(e) => handleMarketLinkFormChange("instagramUrl", e.target.value)} className={inputCls} placeholder="Instagram URL" />
                  <input type="url" value={marketLinkForm.tiktokUrl} onChange={(e) => handleMarketLinkFormChange("tiktokUrl", e.target.value)} className={inputCls} placeholder="TikTok URL" />
                </div>
                <div>
                  <FieldLabel>Brand Description</FieldLabel>
                  <textarea rows={3} value={marketLinkForm.description} onChange={(e) => handleMarketLinkFormChange("description", e.target.value)} className={`${inputCls} resize-none`} placeholder="Short description of your brand" />
                </div>
                <div>
                  <FieldLabel>Brand Logo</FieldLabel>
                  <ImageSlot imageKey="logo" preview={logoPreview} label="Upload Logo" isLogo />
                </div>
              </>
            )}
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <button type="button" onClick={() => toggleModal("createMarketLink", false)} className="px-4 py-2.5 text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors">Cancel</button>
            <button type="submit" disabled={!linkAvailability.available} className={`px-5 py-2.5 text-sm font-semibold rounded-xl transition-colors ${linkAvailability.available ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}>
              {linkAvailability.available ? "Create Store" : "Unavailable"}
            </button>
          </div>
        </form>
      </CustomModal>

      <CustomModal isOpen={modals.editMarketLink} onClose={() => toggleModal("editMarketLink", false)} title="Edit Store" maxWidth="max-w-xl">
        <form onSubmit={updateMarketLink} className="space-y-1">
          <div className="space-y-4">
            <div>
              <FieldLabel>Store URL Name</FieldLabel>
              <input disabled value={editingMarketLink?.link_name || ""} className={`${inputCls} opacity-60 cursor-not-allowed`} />
              <p className="text-xs text-gray-400 mt-1">mygupta.co/s/{editingMarketLink?.link_name}</p>
            </div>
            {(userData?.sub_type === "premium" || userData?.sub_type === "popular" || userData?.sub_type === "free") && (
              <>
                <div>
                  <FieldLabel>Brand Color</FieldLabel>
                  <div className="flex items-center gap-3">
                    <InputColor initialValue={editingMarketLink?.brand_primary_color || "#0071BC"} onChange={(c) => handleMarketLinkFormChange("color", c)} placement="right" />
                    <div className="flex-1 h-10 rounded-xl border-2 border-gray-200 flex items-center justify-center text-white text-xs font-bold" style={{ backgroundColor: marketLinkForm.color.hex }}>
                      {marketLinkForm.color.hex}
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-3">
                  <input type="url" value={marketLinkForm.facebookUrl} onChange={(e) => handleMarketLinkFormChange("facebookUrl", e.target.value)} className={inputCls} placeholder="Facebook URL" />
                  <input type="url" value={marketLinkForm.instagramUrl} onChange={(e) => handleMarketLinkFormChange("instagramUrl", e.target.value)} className={inputCls} placeholder="Instagram URL" />
                  <input type="url" value={marketLinkForm.tiktokUrl} onChange={(e) => handleMarketLinkFormChange("tiktokUrl", e.target.value)} className={inputCls} placeholder="TikTok URL" />
                </div>
                <div>
                  <FieldLabel>Brand Description</FieldLabel>
                  <textarea rows={3} value={marketLinkForm.description} onChange={(e) => handleMarketLinkFormChange("description", e.target.value)} className={`${inputCls} resize-none`} placeholder="Short description of your brand" />
                </div>
                <div>
                  <FieldLabel>Brand Logo</FieldLabel>
                  <div className="flex gap-3 items-start">
                    <div className="flex-1">
                      <ImageSlot imageKey="logo" preview={logoPreview} label="Upload Logo" isLogo />
                    </div>
                    {editingMarketLink?.brand_logo && (
                      <div className="w-24">
                        <img src={editingMarketLink.brand_logo} alt="Current logo" className="w-full h-24 object-cover rounded-xl border border-gray-200" />
                        <p className="text-[10px] text-gray-400 text-center mt-1">Current</p>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <button type="button" onClick={() => toggleModal("editMarketLink", false)} className="px-4 py-2.5 text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors">Cancel</button>
            <button type="submit" className="px-5 py-2.5 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors">Save Changes</button>
          </div>
        </form>
      </CustomModal>

      <CustomModal isOpen={modals.deleteMarketLink} onClose={() => toggleModal("deleteMarketLink", false)} title="Delete Store" maxWidth="max-w-sm">
        <div className="space-y-4">
          <div className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-xl text-sm text-amber-700">
            <AiOutlineWarning size={20} className="flex-shrink-0 mt-0.5" />
            <p>Deleting this store is <strong>permanent</strong>. All products attached to it will also be removed.</p>
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={() => toggleModal("deleteMarketLink", false)} className="px-4 py-2.5 text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors">Cancel</button>
            <button type="button" onClick={deleteMarketLink} disabled={loading} className="px-5 py-2.5 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 disabled:opacity-50 rounded-xl transition-colors">
              {loading ? "Deleting…" : "Delete Store"}
            </button>
          </div>
        </div>
      </CustomModal>

      <ToastContainer position="top-right" autoClose={3000} theme="light" toastStyle={{ borderRadius: "12px" }} />
    </div>
  );
}
